// @ts-check
// ====== F11 UI: bottoni "Export cifrato" / "Import cifrato" nei backup ======
// Si attacca alla card Backup di Sicurezza aggiungendo:
//   - "Export cifrato" accanto a "Crea backup ora"
//   - Drop zone "Carica .mase.enc" per importare uno snapshot esterno
//
// Niente network: chiave derivata client-side, file salvato client-side.

import { encryptBackup, decryptBackup, saveBlob } from '../lib/crypto-export.js';

async function askPassphrase(prompt) {
  // Modal minimale via confirmAction-like flow: usiamo `prompt()` come fallback
  // semplice, mentre il design di un modal dedicato sta nel TODO post-MVP.
  // Per non perdere la passphrase, doppia conferma in export.
  // @ts-ignore — confirmAction globale
  const pwd1 = window.prompt(prompt || 'Passphrase (min 8 caratteri):', '');
  if (!pwd1 || pwd1.length < 8) {
    // @ts-ignore — toast globale
    if (typeof toast === 'function') toast('Passphrase troppo corta (min 8)');
    return null;
  }
  return pwd1;
}

async function exportEncryptedBackup() {
  // @ts-ignore
  if (typeof isAdmin === 'function' && !isAdmin()) return;
  try {
    // Snapshot RPC oppure stato in-memory come fallback
    let payload;
    try {
      // @ts-ignore — sb globale
      const { data, error } = await sb.rpc('build_snapshot');
      if (error) throw error;
      payload = data;
    } catch (_) {
      // @ts-ignore — state globale
      payload = state;
    }
    const pwd1 = await askPassphrase('Passphrase (min 8): proteggerà il backup cifrato');
    if (!pwd1) return;
    const pwd2 = window.prompt('Ripeti la passphrase per conferma:', '');
    if (pwd1 !== pwd2) {
      // @ts-ignore
      toast('Le passphrase non coincidono');
      return;
    }
    const blob = await encryptBackup(payload, pwd1);
    const ts = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
    saveBlob(blob, `portale-mase-${ts}.mase.enc`);
    // @ts-ignore
    toast('Backup cifrato scaricato');
    // @ts-ignore
    logAudit?.({
      action: 'system',
      entity: 'Export',
      target: 'Backup cifrato',
      details: `Snapshot cifrato AES-256-GCM (${blob.size} byte)`
    });
  } catch (e) {
    console.error(e);
    // @ts-ignore
    toast('Errore export cifrato: ' + (e.message || e));
  }
}

async function importEncryptedBackup(file) {
  // @ts-ignore
  if (typeof isAdmin === 'function' && !isAdmin()) return;
  if (!file) return;
  try {
    const pwd = await askPassphrase('Passphrase per decifrare il file:');
    if (!pwd) return;
    const data = await decryptBackup(file, pwd);
    // Scarica come JSON normale per ispezione (non ripristina automaticamente)
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    saveBlob(blob, file.name.replace(/\.mase\.enc$/i, '') + '.json');
    // @ts-ignore
    toast('File decifrato e scaricato come JSON');
    // @ts-ignore
    logAudit?.({
      action: 'system',
      entity: 'Import',
      target: 'Backup cifrato',
      details: 'File .mase.enc decifrato'
    });
  } catch (e) {
    console.error(e);
    // @ts-ignore
    toast('Errore decryption: ' + (e.message || e));
  }
}

function wireEncryptedBackupControls() {
  // Cerca la card backup; se ancora non c'è (render lazy), riprova alla render
  const refresh = () => {
    const btnNow = document.getElementById('btnBackupNow');
    if (!btnNow || document.getElementById('btnBackupEncrypt')) return;
    const parent = btnNow.parentElement;
    if (!parent) return;

    const btn = document.createElement('button');
    btn.id = 'btnBackupEncrypt';
    btn.className = 'btn btn-sm';
    btn.title = 'Esporta un backup completo cifrato AES-256 (passphrase richiesta)';
    btn.innerHTML = `<svg class="btn-svg" viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="11" width="18" height="11" rx="2"/>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
    </svg> Export cifrato`;
    btn.addEventListener('click', exportEncryptedBackup);
    parent.appendChild(btn);

    const fileLabel = document.createElement('label');
    fileLabel.className = 'btn btn-sm';
    fileLabel.style.cursor = 'pointer';
    fileLabel.title = 'Carica un file .mase.enc esportato in precedenza';
    fileLabel.innerHTML = `<svg class="btn-svg" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="17 8 12 3 7 8"/>
      <line x1="12" y1="3" x2="12" y2="15"/>
    </svg> Import cifrato`;
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.mase.enc,application/octet-stream';
    input.style.display = 'none';
    input.id = 'fileBackupEncrypt';
    input.addEventListener('change', () => {
      const f = input.files?.[0];
      if (f) importEncryptedBackup(f);
      input.value = '';
    });
    fileLabel.appendChild(input);
    parent.appendChild(fileLabel);
  };

  // Iniziale + osserva mutazioni nella vista Sicurezza
  refresh();
  const mo = new MutationObserver(() => refresh());
  const target = document.getElementById('view-sicurezza');
  if (target) mo.observe(target, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', wireEncryptedBackupControls);

// @ts-ignore — global
Object.assign(globalThis, { exportEncryptedBackup, importEncryptedBackup });
export {};
